import localStorage from "@/service/storage/localStorageService";

export default {

  install(Vue, options) {
    setInterval(() => {
      localStorage.clearExpire.call(localStorage)
    }, 1000)

    Vue.prototype.$localStorage = {

      /**
       * 保存数据
       * @param key
       * @param value
       * @param expire_time 有效期，单位（秒）
       */
      set(key, value, expire_time) {
        localStorage.set(key, value, expire_time)
      },

      /**
       * 保存对象
       * @param key
       * @param value
       * @param expire_time 有效期，单位（秒）
       */
      setObj(key, value, expire_time) {
        localStorage.setObj(key, value, expire_time)
      },

      /**
       * 获取对象
       * @param key
       */
      getObj(key) {
        return localStorage.getObj(key)
      },

      /**
       * 获取数据
       * @param key
       * @returns {string}
       */
      get(key) {
        return localStorage.get(key)
      },

      /**
       * 删除数据
       * @param key
       */
      remove(key) {
        console.log(key)
        localStorage.remove(key)
      }
    }

  }
}